/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 */
document.addEventListener('variant:changed', function(event) {
var variant = event.detail.variant;
});

  document.addEventListener('product:added', function(event) {
    var variant = event.detail.variant;
    var quantity = event.detail.quantity;
  });


$('.CollectionToolbar__Item--filter').on("click", function(){
  
	let $this = $(this),
        $thisFilterId = $this.data("drawer-id")
    $("#"+$thisFilterId).attr("aria-hidden","false");
})

$('.Drawer__Close').on('click', function(){
	let $this = $(this),
        drawerContainer = $this.parent().parent();
  drawerContainer.attr("aria-hidden","true");
})
let sizeFilters = [];
let colorFilters = [];
$('#collection-size-drawer .Popover__Value').on('click', function(){
	let $this = $(this),
        dataValue = $this.data('value'),
        allCells = $('.ProductList .Grid__Cell');
  
  if(!$this.hasClass('active')){
  	sizeFilters.push(dataValue)
    $this.addClass('active')
  }else{
  	let newSizeFilters = sizeFilters.filter((size)=> (size != dataValue))
    sizeFilters = newSizeFilters;
    $this.removeClass('active')
  }
  

  if(dataValue == "all" || sizeFilters.length == 0){
  	
    $('#collection-size-drawer .Popover__Value').removeClass('active')
    sizeFilters = [];
    if(colorFilters.length > 0){
        colorFilters.map(function(colorfilter){
          allCells.map(function(index, cell){
            if($(cell).hasClass(colorfilter))
              $(cell).show();
          })
        })
    }else{
    	allCells.show();
    }
  } else{
    allCells.hide();
    sizeFilters.map(function(sizefilter){
      if(colorFilters.length > 0){
        colorFilters.map(function(colorfilter){
          allCells.map(function(index, cell){
            if($(cell).hasClass(colorfilter) && $(cell).hasClass(sizefilter))
              $(cell).show();
          })
        })
      }else{
      	allCells.map(function(index, cell){
            if($(cell).hasClass(sizefilter))
              $(cell).show();
          })
      }

    })
    
  }
})

$('#collection-color-drawer .Popover__Value').on('click', function(){
	let $this = $(this),
        dataValue = $this.data('value'),
        allCells = $('.ProductList .Grid__Cell');
  
  if(!$this.hasClass('active')){
  	colorFilters.push(dataValue)
    $this.addClass('active')
  }else{
  	let newcolorFilters = colorFilters.filter((color)=> (color != dataValue))
    colorFilters = newcolorFilters;
    $this.removeClass('active')
  }
  

  if(dataValue == "all" || colorFilters.length == 0){
  	
    $('#collection-color-drawer .Popover__Value').removeClass('active')
    colorFilters = [];
    if(sizeFilters.length > 0){
        sizeFilters.map(function(sizefilter){
          allCells.map(function(index, cell){
            if( $(cell).hasClass(sizefilter))
              $(cell).show();
          })
        })
    }else{
    	allCells.show();
    }
  } else{
    allCells.hide();
    colorFilters.map(function(colorfilter){
      console.log('this 1')
      if(sizeFilters.length > 0){
        
        sizeFilters.map(function(sizefilter ){
          console.log("here", colorfilter, sizefilter)
          allCells.map(function(index, cell){
            if($(cell).hasClass(colorfilter) && $(cell).hasClass(sizefilter))
              $(cell).show();
          })
        })
      }else{
      	 allCells.map(function(index, cell){
            if($(cell).hasClass(colorfilter))
              $(cell).show();
          })
      }

    })
    
  }
})
//       $('#countdown').countdown({
//         year: 2021,
//         month: 01,
//         day: 15,
//         hour: 17,
//         minute: 00,
//         second: 00
//     });


window.RegionSelectorDropdown = (function () {

  var selectors = {
    close: '[data-region-selector-close]',
    selected: '[data-region-selector-selected]',
    list: '[data-region-selector-list-wrapper]',
  };


  function RegionSelectorDropdown(container) {

    this.container = container;
    this.cache = {};
    this._cacheSelectors();
    this._setupListeners();  
  }

  RegionSelectorDropdown.prototype = Object.assign({}, RegionSelectorDropdown.prototype, {

    _cacheSelectors: function () {
      this.cache = {
        selected: this.container.querySelector(
          selectors.selected
        ),
        list: this.container.querySelector(
          selectors.list
        ),
        closeArr: this.container.querySelectorAll(
          selectors.close
        ),
      };
    },

    _setupListeners: function () {
      this.eventHandlers = this._setupEventHandlers();
      this.cache.selected.addEventListener(
        'click',
        this.eventHandlers._handleShowOptions
      );
      this.cache.closeArr.forEach(function (item) {
        item.addEventListener(
          'click',
          this.eventHandlers._handleCloseBtnClick
        );
      }, this);
    },

    _setupEventHandlers: function () {
      return {
        _handleShowOptions: this._handleToggleOptions.bind(this),
        _handleCloseBtnClick: this._handleCloseBtnClick.bind(this),
      };
    },

    _handleCloseBtnClick: function (e) {
      e.preventDefault();
     
      this.cache.list.classList.remove("show");
    },

    _handleToggleOptions: function (e) {
      e.preventDefault();
    
      this.cache.list.classList.toggle("show");
    },
    

  });

  return RegionSelectorDropdown;
})();

if(document.querySelectorAll('[data-region-selector-dropdown-root]').length > 0 ){
  var regionSelectorDropdown = new window.RegionSelectorDropdown(document.querySelector('[data-region-selector-dropdown-root]'));
}

/**
 * Region Selector Modal
 * Display Modal - Section: region-selector.liquid 
*/


window.RegionSelectorModal = (function () {

  var selectors = {
    root: '[data-modal-root]',
    close: '[data-modal-close]',
  };
  var geoipLocationServiceUrl= "https://www.cloudflare.com/cdn-cgi/trace";

  function RegionSelectorModal(container) {

    this.container = container;
    this.cache = {};
    this._cacheSelectors();
    this._setupListeners();
    this._init();
  }

  RegionSelectorModal.prototype = Object.assign({}, RegionSelectorModal.prototype, {

    _cacheSelectors: function () {
      this.cache = {
        root: this.container.querySelector(
          selectors.root
        ),
        closeArr: this.container.querySelectorAll(
          selectors.close
        ),
      };
    },

    _setupListeners: function () {
      this.eventHandlers = this._setupEventHandlers();

      this.cache.closeArr.forEach(function (item) {
        item.addEventListener(
          'click',
          this.eventHandlers._handleCloseBtnClick
        );
      }, this);
    },

    _setupEventHandlers: function () {
      return {
        _handleCloseBtnClick: this._handleCloseBtnClick.bind(this),
      };
    },

    _init:function(){
      if(!this._getLocalSorageFlag()){
        this._fetchData(this._handleGeoLocation.bind(this));
      }
    },

    _fetchData : function(callBack){

      /*
      * Alternative service
      */
      // fetch("https://api.freegeoip.app/json/?apikey=f28daed0-aad9-11ec-b06e-47cd1392cc84")
      // .then(response => response.json())
      // .then(function(data){

      //   if(callBack && typeof callBack === 'function'){
          
      //     if ('country_code' in data){
      //       callBack(data.country_code);
      //     }
       
      //   }
      // })
      // .catch(function(err){
      //   console.log(err);
      // })
      /**************************************/

      fetch(geoipLocationServiceUrl)
      .then(function(res){
        return res.text();
      })
      .then(function(t) {
          var data = t.replace(/[\r\n]+/g, '","').replace(/\=+/g, '":"');
              data = '{"' + data.slice(0, data.lastIndexOf('","')) + '"}';      
              
          var jsondata = JSON.parse(data);
        
          if(callBack && typeof callBack === 'function'){
            if ('loc' in jsondata){
              callBack(jsondata.loc);
            }
               
          }

      }).catch(function(err){
        console.log(err);
      })
      
    },

    addClass: function (elem, classArr) {
      classArr.forEach(function (classname) {
        elem.classList.add(classname);
      })
    },

    removeClass: function (elem, classArr) {
      classArr.forEach(function (classname) {
        elem.classList.remove(classname);
      })
    },

    _handleGeoLocation:function(location){
    
        if(location == "RO"){
          this._setLocalSorageFlag();
          this.cache.root.classList.remove('hidden');
        }        

    },

    _handleCloseBtnClick: function (e) {
      e.preventDefault();
      this.cache.root.classList.add("hidden");
    },

    _setLocalSorageFlag: function (e) {
      // window.localStorage.setItem('regFlag', '1');
      window.sessionStorage.setItem('regFlag', '1');
    },
    _getLocalSorageFlag: function (e) {
      // return window.localStorage.getItem('regFlag') ? true : false;
      return window.sessionStorage.getItem('regFlag') ? true : false;
    },


  });

  return RegionSelectorModal;
})();

if(document.querySelectorAll('.region-selector').length > 0 ){
  var regionSelectorModal = new window.RegionSelectorModal(document.querySelector('.region-selector'));
}

/**
 * Loading a script asynchronously
*/

window.loadScript = function(src, async = false, type = "text/javascript") {
  return new Promise((resolve, reject) => {
      try {
          const el = document.createElement("script");
          const container = document.head || document.body;

          el.type = type;
          el.async = async;
          el.src = src;

          el.addEventListener("load", () => {
              resolve({ status: true });
          });

          el.addEventListener("error", () => {
              reject({
                  status: false,
                  message: `Failed to load the script ${src}`
              });
          });

          container.appendChild(el);
      } catch (err) {
          reject(err);
      }
  });
};

/* Enable ProductItems Image Swipe*/
window.ProductItemSwipe = (function () {

  var selectors = {
    item: ':not(.Carousel,.Carousel__Cell) > .ProductItem .ProductItem__ImageWrapper--withAlternateImage',
    dots: '.ProductItem--dots .dot',
  };

  function ProductItemSwipe() {
    this.cache = {};
    this._cacheSelectors();
    this._setupListeners();
  }

  ProductItemSwipe.prototype = Object.assign({}, ProductItemSwipe.prototype, {
    _cacheSelectors: function () {
      this.cache = {
        productItemArr: document.querySelectorAll(
          selectors.item
        )
      };
    },

    _setupListeners: function () {
      this.eventHandlers = this._setupEventHandlers();

      this.cache.productItemArr.forEach(function (elem) {
        elem.addEventListener('swiped-left', this.eventHandlers._handleSwipe);     
        elem.addEventListener('swiped-right', this.eventHandlers._handleSwipe);
      }, this);
    },

    _setupEventHandlers: function () {
      return {
        _handleSwipe: this._handleSwipe.bind(this),
      };
    },

    _handleSwipe: function(elem){

      var parentElem = elem.target.closest('.ProductItem__ImageWrapper--withAlternateImage');
      parentElem.classList.toggle('swipe-image');
      this._handleDotSwitch(parentElem);
    },

    _handleDotSwitch: function(elem){

      var dots = elem.querySelectorAll(selectors.dots);
      dots.forEach(function(el){
        el.classList.toggle('is-selected');
      })
    }

  })

  return ProductItemSwipe;
})();

var productItemSwipe = new window.ProductItemSwipe();
/* Mobile Collection Item Image Swipe*/
